export function createNoAccessPath({ reason, action, returnUrl }) {
  const params = new URLSearchParams()

  if (reason) params.set('reason', reason)
  if (action) params.set('action', action)
  if (returnUrl) params.set('returnUrl', returnUrl)

  return `/no-access?${params.toString()}`
}

export function getSafeReturnUrl(value) {
  const returnUrl = Array.isArray(value) ? value[0] : value

  if (!returnUrl || typeof returnUrl !== 'string') return null
  if (!returnUrl.startsWith('/') || returnUrl.startsWith('//')) return null

  return returnUrl
}
